<template>
  <div id="users-list">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Listagem de usuários">
      <!-- SIDEBAR -->
      <template #sidebar>
        <Heading element="h2" class="sidebar-title">
          Ações da página
        </Heading>
        <div class="sidebar-buttons">
          <Button
            :hasIcon="true"
            class="sidebar-buttons--create"
            @click.stop.prevent="$router.push({ path: 'usuarios/novo' })"
          >
            Criar usuário
          </Button>
          <Button
            :disabled="disableEditButton"
            class="sidebar-buttons--edit"
            @click.stop.prevent="
              $router.push({
                path: `usuarios/editar/${selectedRows[0].codigo}`
              })
            "
          >
            Editar
          </Button>
          <Button
            :disabled="disabledDeleteButton"
            variation="error"
            class="sidebar-buttons--delete"
            @click.stop.prevent="deleteModal(selectedRows.codigo)"
          >
            Excluir
          </Button>
        </div>
      </template>
      <!-- CONTEÚDO -->
      <template #content>
        <span class="filters">
          <!-- BUSCA -->
          <SearchInput v-model="filterByName" class="filters--search-input" />
        </span>
        <span class="extra-filters">
          <!-- FILTRO STATUS -->
          <FilterDropdown
            v-model="statusFilter"
            :options="statusFilterOptions"
            class="extra-filters--status"
          />
          <!-- FILTRO REVENDEDOR -->
          <FilterDropdown
            v-model="resellerFilter"
            :options="resellerFilterOptions"
            label="Revendedor"
            class="extra-filters--reseller"
          />
        </span>
        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :colsMinWidths="colsMinWidths"
          :sortable="true"
          :isLoading="loading"
          :rows="rows"
          :selectableRow="true"
          ref="dataTable"
          maxHeight="1080"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:status="data">
            <div v-if="data.rowDataObj.status == false">
              Ativo
            </div>
            <div v-else>
              Expirado
            </div>
          </template>

          <template v-slot:editar="data">
            <button
              class="links edit"
              @click.stop.prevent="
                $router.push({
                  path: `usuarios/editar/${data.rowDataObj.codigo}`
                })
              "
            >
              Editar
            </button>
          </template>

          <template v-slot:excluir="data">
            <div v-if="data.rowDataObj.status == false">
              <button
                class="links delete"
                @click.stop.prevent="deleteModal(data.rowDataObj.codigo)"
              >
                Excluir
              </button>
            </div>
            <div v-else>
              <button
                class="links edit"
                @click.stop.prevent="
                  reactivateUser(data.rowDataObj.codigo),
                    (userReactivate = data.rowDataObj.codigo)
                "
              >
                Reativar
              </button>
            </div>
          </template>
        </DataTable>
        <!-- PAGINAÇÃO -->
        <PmwPagination
          :items="filterTable"
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="filterTable.length"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          class="pagination"
          @changePagination="changePagination"
        />
        <!-- MODAL DELEÇÃO -->
        <AlertModal
          v-model="showDeleteModal"
          :buttonClose="true"
          title="Excluir usuário"
          @alert-modal-cancel="cancelDisable()"
          @alert-modal-confirm="disableUser()"
        >
          <template #text>
            Este usuário não conseguirá mais entrar na conta. <br />
            Tem certeza que quer fazer isso?
          </template>
        </AlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'UsersList',
  components: {
    AlertModal,
    Button,
    DataTable,
    FilterDropdown,
    Heading,
    PmwPagination,
    SearchInput,
    SidebarLayout2
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Usuários'
        }
      ],
      /** Filtros */
      filters: [],
      options: [
        {
          text: 'E-mail',
          type: 'search',
          name: 'email',
          placeholder: 'Digite o e-mail' /** opcional */,
          value: '' /** opcional */
        },
        {
          text: 'Nome',
          type: 'search',
          name: 'nome',
          placeholder: 'Digite o Nome' /** opcional */,
          value: '' /** opcional */
        },
        {
          text: 'Login',
          type: 'search',
          name: 'login',
          placeholder: 'Digite o Login' /** opcional */,
          value: '' /** opcional */
        },
        /** Campo de seleção */
        {
          text: 'Status',
          type: 'select',
          name: 'status',
          description: 'Selecione' /** opcional */,
          search: true /** opcional */,
          multiple: true /** opcional */,
          options: [
            { text: 'Ativo', value: true },
            { text: 'Expirado', value: false }
          ],
          value: [
            { text: 'Ativo', value: true },
            { text: 'Expirado', value: false }
          ] /** opcional */
        },
        {
          text: 'Usuário Revendedor',
          type: 'select',
          name: 'revendedor',
          description: 'Selecione' /** opcional */,
          search: true /** opcional */,
          multiple: true /** opcional */,
          options: [
            { text: 'Sim', value: true },
            { text: 'Não', value: false }
          ],
          value: [
            { text: 'Sim', value: true },
            { text: 'Não', value: false }
          ] /** opcional */
        }
      ],
      /** Colunas da tabela */
      cols: [
        {
          alias: 'Login',
          name: 'login'
        },
        {
          alias: 'Nome',
          name: 'nome'
        },
        {
          alias: 'Email',
          name: 'email'
        },
        {
          alias: 'Status',
          name: 'status'
        },
        {
          alias: 'Ações',
          name: 'editar'
        },
        {
          name: 'excluir'
        }
      ],
      /** Largura mínima das colunas */
      colsMinWidths: {
        login: '231px',
        nome: '202px',
        email: '235px',
        status: '113px',
        editar: '71px',
        excluir: '71px'
      },
      /** V-model da busca */
      filterByName: '',
      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 25,
        startItemIndex: 1,
        lastItemIndex: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },
      /** Linhas da tabela (dados) */
      rows: [],
      /** Armazena dados de retorno */
      allUsers: [],
      /** Loading da tabela */
      loading: true,
      /** Array das linhas selecionadas */
      selectedRows: [],
      /** Usuário a ser deletado */
      userDelete: null,
      userReactivate: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      /** Opções do filtro de status */
      statusFilterOptions: [
        {
          label: 'Todos',
          value: -1,
          checked: false
        },
        {
          label: 'Ativo',
          value: 1,
          checked: true
        },
        {
          label: 'Expirado',
          value: 0,
          checked: false
        }
      ],
      /** Opções do filtro de revendedor */
      resellerFilterOptions: [
        {
          label: 'Todos',
          value: -1,
          checked: true
        },
        {
          label: 'Sim',
          value: 1,
          checked: false
        },
        {
          label: 'Não',
          value: 0,
          checked: false
        }
      ],
      /** V-model do filtro de status */
      statusFilter: {
        label: 'Ativo',
        value: 1,
        checked: true
      },
      /** V-model do filtro de revendedor */
      resellerFilter: {
        label: 'Todos',
        value: -1,
        checked: true
      }
    }
  },
  computed: {
    disabledDeleteButton() {
      if (this.selectedRows.length >= 1) {
        return false
      }
      return true
    },
    disableEditButton() {
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },

    /** Filtro da tela */
    filterTable() {
      return this.allUsers.reduce((acc, curr) => {
        let match = true
        let seller = true

        /** Filtra por status */
        match =
          +curr.status === +this.statusFilter.value ||
          +this.statusFilter.value === -1

        /** Filtra por revendedor */
        seller =
          +curr.revendedor === +this.resellerFilter.value ||
          +this.resellerFilter.value === -1

        if (
          curr.email !== null &&
          curr.login !== null &&
          curr.nome !== null &&
          match &&
          seller
        ) {
          acc.push(curr)
        }

        /** Filtra pelo input */
        const results = acc.filter((data) => {
          return (
            data.nome.toLowerCase().indexOf(this.filterByName.toLowerCase()) >
              -1 ||
            data.email.toLowerCase().indexOf(this.filterByName.toLowerCase()) >
              -1 ||
            data.login.toLowerCase().indexOf(this.filterByName.toLowerCase()) >
              -1
          )
        })
        return results
      }, [])
    }
  },
  created() {
    /** Faz a chamada da api */
    this.getAllUsers()
  },
  methods: {
    /** Retorna dados da listagem */
    getAllUsers() {
      this.loading = true
      this.$user.getUsersList().then((response) => {
        const results = response.data
        results.map(function(key, index) {
          key.status = !key.expirado
          results[index]['data'] = {
            email: key.email,
            status: key.expirado,
            login: key.login,
            nome: key.nome,
            codigo: key.codigo,
            revendedor: key.revendedor
          }
          if (!results.email) {
            results.email = ''
          }
        })
        this.allUsers = results
      })
      this.loading = false
    },

    /** Reativar usuário */
    reactivateUser(usuario) {
      this.$user
        .reactivateUser(usuario)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Usuário reativado com sucesso'
          })
          this.getAllUsers()
          this.userReactivate = null
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao reativar usuário'
          })
        })
    },

    /** Desabilitar usuário */
    disableUser() {
      const DeleteUsers = this.ifExists(
        this.selectedRows.length > 0
          ? this.selectedRows.map((item) => {
              return parseInt(item.codigo)
            })
          : [this.userDelete]
      )
      this.userReactivate = DeleteUsers
      this.$user
        .disableUser({ usuarios: DeleteUsers })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Usuário excluido com sucesso'
          })
          this.getAllUsers()
          this.resetPagination()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar usuários'
          })
        })
    },

    /** Controle de deleção */
    deleteModal(userId) {
      this.showDeleteModal = true
      this.userDelete = userId
    },

    /** Cancela deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.userDelete = null
    },

    /** Verificar se dado existe */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Usado para controle da paginação */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.pagination {
  ::v-deep {
    p {
      margin: 0;
    }
    .select--button {
      font-weight: 500;
    }
  }
}
::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}
.sidebar {
  &-title {
    line-height: 21px;
    color: #474747;
    text-align: left;
    margin-top: 35px;
    margin-bottom: 15px;
    margin-left: 15px;
  }
  &-buttons {
    display: flex;
    flex-direction: column;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}
.filters {
  display: flex;
  gap: 20px;

  &--search-input {
    width: 215px;
  }

  &--more {
    width: 225px;
  }
}
.extra-filters {
  display: flex;
  gap: 20px;
  margin-top: 15px;
  margin-bottom: 30px;

  &--status {
    width: 140px;
  }

  &--reseller {
    width: 160px;
  }
}
.links {
  border: none;
  background-color: inherit;
  &.edit {
    color: #466af0;
  }
  &.delete {
    color: #e0414b;
  }
}
.datatable {
  ::v-deep {
    .pmw-col.pmw-th:nth-child(6) {
      pointer-events: none;
      border-right: none;
      .pmw-sort-icons {
        display: none;
      }
    }
    .pmw-col.pmw-th:nth-child(7) {
      pointer-events: none;
      .pmw-sort-icons {
        display: none;
      }
    }
  }
  .action {
    &--item {
      font-size: font-size('size-small');
    }
  }
}
.filters-select {
  display: flex;
  width: 100%;
  position: relative;
  height: 40px;
  border: none;
  border-bottom: 1px solid #474747;

  & ::v-deep .pmw-dropdown--trigger-button {
    /** Remove o espaço antes do texto do dropdown de mais filtros */
    padding: 0;
  }
}
</style>
